<template>
  <div>
  <!-- 页面标题区域 -->
  <div class="page-header" :style="{ backgroundImage: `url('${bannerBg}')` }">
    <div class="header-bg"></div>
    <div class="container">
      <h1 class="page-title">{{ $t('products.centerTitle') }}</h1>
      <div class="search-container">
        <div class="search-box">
          <el-input
          v-model="searchKeyword"
          :placeholder="$t('products.searchPlaceholder')"
          class="search-input"
          @keyup.enter.native="handleSearch">
        <template #prefix>
          <img @click.stop="scanCode" src="@/assets/images/products/scan.png" class="search-input-scan" />
        </template>
        <template #suffix>
          <el-button type="primary" class="search-btn" @click="handleSearch">
            {{ $t('products.searchBtn') }}
          </el-button>
        </template>
      </el-input>
        </div>
      </div>
    </div>
  </div>

    <code-prop
        v-if="isScannerOpen"
        :visible="isScannerOpen"
        @decode="handleDecode"
        @closePopup="isScannerOpen = false"
    />
  </div>
</template>

<script>
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { mapState } from 'vuex'
import { pushWithLanguage } from '@/utils/routeUtils'
import codeProp from "@/views/product/codeProp.vue";

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ProductsHead',

  data() {
    return {
      bannerBg: 'https://file.yacoo.com.cn/staticResource/products/products-header-bg.webp?x-oss-process=image/resize,h_480',
      searchKeyword: '',
      queryParams: {
        category: '',
        keyword: ''
      },
      isScannerOpen: false, // 控制扫码组件显示状态
    }
  },

  components: {
    codeProp
  },


  computed: {
    ...mapState({
      currentLanguage: state => state.app.language
    })
  },
  methods: {

    handleSearch() {
      const kw = (this.searchKeyword || '').trim()
      if (!kw) {
        this.$message.info(this.$t('products.searchPlaceholder') || '请输入关键词')
        return
      }
      pushWithLanguage('/ProductsSearch', this.currentLanguage, { keyword: kw }).catch(err => {
        if (err && err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },
    scanCode() {
      this.isScannerOpen = true;
    },
    /**
     * 处理扫码结果
     * @param {string} result 二维码内容
     */
     handleDecode(result) {
      try {
        const raw = (result || '').trim()
        const urlStr = raw.startsWith('@') ? raw.slice(1) : raw
        const u = new URL(urlStr)
        const batchNo = u.searchParams.get('batchNo')
        const sn = u.searchParams.get('sn')

        if (!batchNo || !sn) {
          this.$message.error('二维码参数缺失')
          return
        }

        this.isScannerOpen = false
        pushWithLanguage('/products/check', this.currentLanguage, { batchNo, sn }).catch(err => {
          if (err && err.name !== 'NavigationDuplicated') {
            console.error(err)
          }
        })
      } catch (e) {
        this.$message.error('二维码内容无效')
        console.error(e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/styles/variables.less';
@import '@/assets/styles/mixins.less';

.page-header {
  .container {
    position: relative;
    z-index: 2;
    width: 100%;
    padding: 0 20px;
    text-align: center;
  }

  .search-container {
    width: 100%;

    .search-box {
      width: 100%;

      .search-input {
        :deep(.el-input__inner) {
          height: 30px;
          border: none;
          border-radius: 16px;
          padding-left: 40px;
          padding-right: 60px;
          background: #FFFFFF;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          font-size: 12px;

          //placeholder 的样式
          &::placeholder {
            font-size: 11px;
          }
        }

        .search-input-scan {
          width: 14px;
          height: 14px;
        }

        :deep(.el-input__prefix) {
          left: 10px;
          font-size: 10px;
          height: 100%;
          display: flex;
          align-items: center;
          &::after {
            content: ' ';
            position: absolute;
            right: -8px;
            top: 5px;
            width: 1px;
            height: 20px;
            background-color: #CECECE;
          }
        }

        :deep(.el-input__suffix) {
          right: 4px;
          height: 100%;
          display: flex;
          align-items: center;
        }

        .search-btn {
          width: 50px;
          height: 26px;
          border-radius: 18px;
          background-color: #19529F;
          font-size: 12px;

          padding: 0;
        }
      }
    }
  }
}
</style>